// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic$dForm$dTestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $CreatorCrossSellingPresentation = tag => ({tag});
const InlineIsSymbol = {reflectSymbol: () => "Inline"};
const PopupIsSymbol = {reflectSymbol: () => "Popup"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor)(genericEnumConstructor)(genericBottomConstructor);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor)(genericBoundedEnumConstructor);
const Inline = /* #__PURE__ */ $CreatorCrossSellingPresentation("Inline");
const Popup = /* #__PURE__ */ $CreatorCrossSellingPresentation("Popup");
const eqCreatorCrossSellingPres = {
  eq: x => y => {
    if (x.tag === "Inline") { return y.tag === "Inline"; }
    if (x.tag === "Popup") { return y.tag === "Popup"; }
    return false;
  }
};
const ordCreatorCrossSellingPre = {
  compare: x => y => {
    if (x.tag === "Inline") {
      if (y.tag === "Inline") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Inline") { return Data$dOrdering.GT; }
    if (x.tag === "Popup") {
      if (y.tag === "Popup") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqCreatorCrossSellingPres
};
const genericCreatorCrossSellingPresentation = {
  to: x => {
    if (x.tag === "Inl") { return Inline; }
    if (x.tag === "Inr") { return Popup; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Inline") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Popup") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showCreatorCrossSellingPresentation = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InlineIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PopupIsSymbol);
    return x => {
      if (x.tag === "Inline") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "Popup") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeCreatorCrossSellingPresentation = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericCreatorCrossSellingPresentation)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Inline"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Popup"), Data$dGeneric$dRep.NoArguments)]}))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedCreatorCrossSellin = {top: Popup, bottom: Inline, Ord0: () => ordCreatorCrossSellingPre};
const enumCreatorCrossSellingPr = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericCreatorCrossSellingPresentation)(genericEnumSum),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericCreatorCrossSellingPresentation)(genericEnumSum),
  Ord0: () => ordCreatorCrossSellingPre
};
const boundedEnumCreatorCrossSe = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericCreatorCrossSellingPresentation)(genericBoundedEnumSum),
    fromEnum: x => genericBoundedEnumSum["genericFromEnum'"]((() => {
      if (x.tag === "Inline") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "Popup") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    })()),
    Bounded0: () => boundedCreatorCrossSellin,
    Enum1: () => enumCreatorCrossSellingPr
  }
))();
const experimentVariantCreatorC = {
  experimentName: v => "CreatorCrossSellingPresentation",
  weight: v => 1,
  Bounded0: () => boundedCreatorCrossSellin,
  Enum1: () => enumCreatorCrossSellingPr,
  Show2: () => showCreatorCrossSellingPresentation
};
const toFillFormTypeCreatorCros = {
  fillFormDataType: /* #__PURE__ */ Restaumatic$dForm$dTestHelpers.defaultEnumFillFormDataType(genericCreatorCrossSellingPresentation)(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"Inline\""
  })({gdefaultEnumFillFormDataType: v => "\"Popup\""}))
};
const encodeCreatorCrossSellingPresentation = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericCreatorCrossSellingPresentation)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("Inline"); }
      if (v1.tag === "Inr") { return v.constructorTagTransform("Popup"); }
      $runtime.fail();
    }
  })
};
const decodeCreatorCrossSellingPresentation = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericCreatorCrossSellingPresentation)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(InlineIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(PopupIsSymbol)))
};
export {
  $CreatorCrossSellingPresentation,
  Inline,
  InlineIsSymbol,
  Popup,
  PopupIsSymbol,
  boundedCreatorCrossSellin,
  boundedEnumCreatorCrossSe,
  decodeCreatorCrossSellingPresentation,
  encodeCreatorCrossSellingPresentation,
  enumCreatorCrossSellingPr,
  eqCreatorCrossSellingPres,
  experimentVariantCreatorC,
  genericBottomConstructor,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericCreatorCrossSellingPresentation,
  genericEnumConstructor,
  genericEnumSum,
  genericTopConstructor,
  ordCreatorCrossSellingPre,
  showCreatorCrossSellingPresentation,
  toFillFormTypeCreatorCros,
  unscrambleDecodeCreatorCrossSellingPresentation
};
